import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import MainLayout from './Layout/MainLayout';
import PublicLayout from './Layout/PublicLayout';
import UserManagement from './Pages/Settings/UserManagement';
import OrganizationManagement from './Pages/Settings/OrganizationManagement';
import BannerManagement from './Pages/Settings/BannerManagement';
import ReviewManagement from './Pages/Settings/ReviewManagement';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Pages/Login/Login';
import './Pages/Common/common.css';

// Public E-commerce Pages
import ProductListing from './Pages/Public/ProductListing';
import ProductDetails from './Pages/Public/ProductDetails';
import ShoppingCart from './Pages/Public/ShoppingCart';
import Checkout from './Pages/Public/Checkout';
import CustomerLogin from './Pages/Public/CustomerLogin';
import CustomerRegister from './Pages/Public/CustomerRegister';
import CustomerOrders from './Pages/Public/CustomerOrders';
import OrderConfirmation from './Pages/Public/OrderConfirmation';

// Admin E-commerce Pages
import ECommerceDashboard from './Pages/Admin/ECommerceDashboard';
import AdminProducts from './Pages/Admin/AdminProducts';
import AdminOrders from './Pages/Admin/AdminOrders';
import OrderDetails from './Pages/Admin/OrderDetails';

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Public Routes (Customer-facing) */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<ProductListing />} />
            <Route path="/shop" element={<ProductListing />} />
            <Route path="/product/:slug" element={<ProductDetails />} />
            <Route path="/cart" element={<ShoppingCart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/customer/login" element={<CustomerLogin />} />
            <Route path="/customer/register" element={<CustomerRegister />} />
            <Route path="/orders" element={<CustomerOrders />} />
            <Route path="/order/:id" element={<CustomerOrders />} />
            <Route path="/order-confirmation/:id" element={<OrderConfirmation />} />
          </Route>

          {/* Admin/Internal System Login */}
          <Route path="/admin-login" element={<Login />} />
          <Route path="/login" element={<Login />} /> {/* Alternative route */}

          {/* Admin/Internal System Routes */}
          <Route
            path="/Home/*"
            element={
              <MainLayout>
                <Routes>
                  <Route path="Dashboard" element={<ECommerceDashboard />} />
                  <Route path="ECommerce-Dashboard" element={<ECommerceDashboard />} />
                  <Route path="Admin-Products" element={<AdminProducts />} />
                  <Route path="Admin-Orders" element={<AdminOrders />} />
                  <Route path="OrderDetails/:id" element={<OrderDetails />} />
                  <Route path="User-Management" element={<UserManagement />} />
                  <Route path="Organization-Management" element={<OrganizationManagement />} />
                  <Route path="Banner-Management" element={<BannerManagement />} />
                  <Route path="Review-Management" element={<ReviewManagement />} />
                </Routes>
              </MainLayout>
            }
          />
        </Routes>
      </Router>
      <ToastContainer
        position="top-left"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
